import { UserActionTypes, UserActions } from "../actionTypes/userActionTypes";
import { IUserInitialState } from "../../types/userInterface";

const initialState: IUserInitialState = {
  authStatus: false,
  myProfile: {
    id: 0,
    name: "",
    official_email: "",
    profile_photo: "",
    profile_status: "",
    role: {
      id: 0,
      role_name: "",
      slug: "",
      department_id: 0,
    },
    department: {
      id: 0,
      department_label: "",
      slug: "",
    },
    username: "",
  },
  userList: [],
  userListPageCount: 0,
  userData: {
    id: 0,
    name: "",
    official_email: "",
    personal_email: "",
    gender: "",
    username: "",
    department_id: 0,
    branch_id: 0,
    role_id: 0,
    role: {
      id: 0,
      role_name: "",
      department: {
        id: 0,
        department_label: "",
      },
    },
    authority: [],
    personal_contact_number: "",
    official_contact_number: "",
    dob: "",
    joining_date: "",
    termination_date: "",
    reporting_officer_id: 0,
    profile_status: "",
    profile_photo: "",
    employee_contract_url: "",
    created_by: "",
    hr_rule_id: 0,
    type: "",
    current_address: "",
    permanent_address: "",
    blood_group: "",
    marital_status: "",
    user_documents: [],
    user_office_location_data: {
      id: 0,
      location_name: "",
    },
    assigned_location_data: [
      {
        id: 0,
        user_id: 0,
        office_location_id: 0,
      },
    ],
  },
  loggedInUserData: {
    id: 0,
    name: "",
    official_email: "",
    username: "",
    user_code: "",
    department_id: 0,
    branch_id: 0,
    role_id: 0,
    hr_rule_id: 0,
    authority: [],
    office_assigned_data: [
      {
        label: "",
        value: 0
      }
    ],
    user_office_location_data: {
      id: 0,
      location_name: ""
    },
    official_contact_number: "",
    alternate_contact_number: "",
    dob: "",
    joining_date: "",
    termination_date: "",
    reporting_officer_id: 0,
    profile_status: "",
    profile_photo: "",
    employee_contract_url: "",
    created_by: 0,
    type: "",
    blood_group: "",
    gender: "",
    personal_email: "",
    personal_contact_number: "",
    current_address: "",
    permanent_address: "",
    marital_status: "",
    branch: {
      id: 0,
      branch_name: "",
      pincodes: {
        id: 0,
        pincode: 0,
      },
    },
    role: {
      id: 0,
      role_name: "",
      department: {
        id: 0,
        department_label: "",
      },
    },
    hr_rules: {
      label: "",
    },
    reporting_officer_data: {name:""},
    permissions: [],
  },
};

export default function userReducer(state = initialState, action: UserActionTypes): IUserInitialState {
  switch (action.type) {
    case UserActions.SET_USER:
      return {
        ...state,
        authStatus: true,
        myProfile: action.payload,
      };

    case UserActions.SET_USER_LIST:
      return {
        ...state,
        userList: action.payload,
      };

    case UserActions.SET_USER_LIST_PAGE_COUNT:
      return {
        ...state,
        userListPageCount: action.payload,
      };

    case UserActions.SET_USER_DATA_BY_ID:
      return {
        ...state,
        userData: action.payload,
      };

    case UserActions.SET_LOGGEDIN_USER_DATA:
      return {
        ...state,
        loggedInUserData: action.payload,
      };
    default:
      return state;
  }
}
